import React from 'react';
import { Checkbox } from 'react-form';
import InfoButton from '../../InfoButton';
import Img from '../../Img';

const CheckboxButton = ({ id, title, description, field, disabled, hoverText, onChange, 'data-testid': dataTestId }) => {
    return (
        <div
            className={`radio-button noselect ${disabled ? 'disabled' : ''}`}
            data-testid={dataTestId || undefined}
            onChange={(ev) => {
                if (onChange) {
                    setTimeout(() => {
                        onChange(ev);
                    }, 100);
                }
            }}
        >
            <Checkbox id={id} field={field} disabled={disabled} data-testid={dataTestId && `${dataTestId}.input`} />
            <label htmlFor={id}>
                <div className="radio-button-label">
                    <div className="radio-button-title" data-testid={dataTestId && `${dataTestId}.title`}>{title} {hoverText && <InfoButton hoverText={hoverText} />}</div>
                    <div className="radio-button-description" data-testid={dataTestId && `${dataTestId}.description`}>{description}</div>
                </div>
                <div className="checkbox-check"><Img src="/img/icons/checkmark-icon.svg" /></div>
            </label>
        </div>
    );
};

export default CheckboxButton;
